import z from 'zod'

export const statisticsFilterSchema = z.object({
  videoViews: z.array(z.number()),
  tiktokFollowers: z.array(z.number()),
})

export type StatisticsFiltersForm = z.infer<typeof statisticsFilterSchema>

export const defaultValuesStatisticsFiltersForm: StatisticsFiltersForm = {
  videoViews: [0, 50000000],
  tiktokFollowers: [0, 50000000],
}
